export function dvdMove(componentId: string, isFast: boolean) {
    const dvd = document.getElementById(componentId);
    if (dvd !== null) {
        const placeholder = document.createElement('div');
        placeholder.style.width = `${dvd.offsetWidth}px`;
        placeholder.style.height = `${dvd.offsetHeight}px`;
        dvd.parentNode?.insertBefore(placeholder, dvd);

        dvd.style.position = 'fixed';
        dvd.style.zIndex = '99999999';

        const dvdWidth = dvd.offsetWidth;
        const dvdHeight = dvd.offsetHeight;

        let { left: x, top: y } = dvd.getBoundingClientRect();

        let dirX = 1;
        let dirY = 1;

        const screenWidth = window.innerWidth || document.documentElement.clientWidth;
        const screenHeight = window.innerHeight || document.documentElement.clientHeight;

        setInterval(
            () => {
                if (y + dvdHeight > screenHeight || y < 0) {
                    dirY *= -1;
                }
                if (x + dvdWidth > screenWidth || x < 0) {
                    dirX *= -1;
                }

                x += dirX * 2;
                y += dirY * 2;
                dvd.style.left = x + 'px';
                dvd.style.top = y + 'px';
            },
            isFast ? 1000 / 360 : 1000 / 60,
        );
    }
}
